module.exports = __webpack_public_path__ + "media/aerial-farm-hd03.7f1e0168.mp4";